import $ from 'jquery';

import plugin from './plugin';

class PluginBuybox {

	constructor(element, options) {
		const $element = this.$element = $(element);
		if ($element.find('.m-buybox-subscription').length === 0) return;


		// this is repepated from switch.js, but I need it here for the basket link render
		this.$switch = $element.find('.m-switch-switch');
		this.$button = $element.find('.btn-buy-now');
		this.origBtnTitle = this.$button.text();
		this.origUrl = this.$button.attr('href');
		this.purchaseUrl = this.$button.data('purchase-url') || this.origUrl;
		$element.on('switchrender', () => this.render());

		this.$subscriptionRow = {
			month: $element.find('.m-buybox-row-subscription.month'),
			year: $element.find('.m-buybox-row-subscription.year'),
		};

		this.subscriptionPeriod = 'month';

		for (const [key, $val] of Object.entries(this.$subscriptionRow)) {
			$val.on('click', () => this.setSubscriptionPeriod(key));
		}
		this.render();
	}

	setSubscriptionPeriod(period) {
		this.subscriptionPeriod = period;
		this.render();
	}

	render() {
		for (const [key, $val] of Object.entries(this.$subscriptionRow)) {
			if (key === this.subscriptionPeriod) {
				$val.addClass('active');
			} else {
				$val.removeClass('active');
			}
		}
		const switchState = this.$element.hasClass('active');

		this.$button.text(switchState ? 'Subscribe' : this.origBtnTitle);

		let url;
		if (switchState) {
			url = new URL(this.purchaseUrl, (new URL(window.location.href)).origin);
			url.searchParams.delete('subscription');
			url.searchParams.set('subscription', `${this.subscriptionPeriod}ly`);
			url = url.toString();
		} else {
			url = this.origUrl;
		}
		this.$button.attr('href', url);

	}
}

plugin('PluginBuybox', PluginBuybox);

